import { render, staticRenderFns } from "./insertBank.vue?vue&type=template&id=470c155d"
import script from "./insertBank.vue?vue&type=script&lang=js"
export * from "./insertBank.vue?vue&type=script&lang=js"
import style0 from "./insertBank.vue?vue&type=style&index=0&id=470c155d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports